import React from "react";

export default function EmptyStateCard({
  icon = "📭",
  title = "Nothing here yet",
  message = "There is no data to show right now.",
  action = null,
  compact = false
}) {
  return (
    <div className={`empty-state-card ${compact ? "compact" : ""}`}>
      <div className="empty-state-icon">{icon}</div>
      <div className="empty-state-title">{title}</div>
      <div className="empty-state-message">{message}</div>
      {action ? <div className="empty-state-action">{action}</div> : null}
    </div>
  );
}